<template>
  <v-app>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex class="text-sm-center" style="max-width:400px">
          <img src="../../assets/logo.png" width="400" alt="" />
          <h2 class="headline" style="color:#4a89dc;font-weight:300">
            <v-icon>fa-spin fa-cog</v-icon> Platform Updating
          </h2>
          <v-card style="text-align:center">
            <v-card-text>
              <h4>We are carrying out some essential maintenance and the platform is currently unavailable</h4>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'Maintenance',
  components: {},
  data: () => ({}),
  computed: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
h2 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

a.btn {
  margin: 18px 0;
}

::v-deep {
  a .btn__content {
    padding: 1rem 0;
  }
}
</style>
